import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import ReactPlayer from 'react-player';

import { Button, Hexagon } from '@keethealth/keet-ui';
import Modal from 'common/Modal';
import { isVimeoPlayerUrl, formatVimeoPlayerUrl } from 'utils/content';
import COMPLETE_TASK from 'graph/mutations/completeTask';

export class TaskDetail extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    completed: PropTypes.bool.isRequired,
    description: PropTypes.string.isRequired,
    equipment: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quantities: PropTypes.array.isRequired,
    videoUrl: PropTypes.string.isRequired,
    completeTask: PropTypes.func.isRequired,
  }

  state = {
    isModalOpen: false,
  }

  handleOpenModal = () => {
    this.setState({
      isModalOpen: true,
    });
  }

  handleCloseModal = () => {
    this.setState({
      isModalOpen: false,
    });
  }

  handleComplete = () => {
    const { id, completeTask } = this.props;
    completeTask(id, true);
  }

  renderQuantities = () => {
    const { quantities } = this.props;
    if (quantities.length === 3) {
      return (
        <div className="w-100 pa3 bg-white bt bb">
          <div className="flex mw8 center">
            <div className="flex-auto">
              <Hexagon
                color="primary"
                label={quantities[0].count}
              />
              <span className="db tc mv2">{quantities[0].type.toUpperCase()}</span>
            </div>
            <div className="flex-auto">
              <Hexagon
                color="tertiary"
                label={quantities[1].count}
              />
              <span className="db tc mv2">{quantities[1].type.toUpperCase()}</span>
            </div>
            <div className="flex-auto">
              <Hexagon
                color="secondary"
                label={quantities[2].count}
              />
              <span className="db tc mv2">{quantities[2].type.toUpperCase()}</span>
            </div>
          </div>
        </div>
      );
    }
    return <noscript />;
  }

  renderModal = () => {
    const { videoUrl } = this.props;
    const { isModalOpen } = this.state;
    let formattedUrl = videoUrl;
    if (isVimeoPlayerUrl(videoUrl)) {
      formattedUrl = formatVimeoPlayerUrl(videoUrl);
    }
    return (
      <Modal
        isOpen={isModalOpen}
        onRequestClose={this.handleCloseModal}
      >
        <ReactPlayer width="100%" height="100%" url={formattedUrl} />
      </Modal>
    );
  }

  render() {
    const {
      description,
      equipment,
      imageUrl,
      name,
      quantities,
      completed,
      videoUrl,
      completeTask,
      ...remainingProps
    } = this.props;
    return (
      <div {...remainingProps}>
        <div className="flex flex-column items-center">
          {imageUrl &&
            <div className="task-preview w-100">
              <div
                className="mw6 tc center pointer"
                onClick={this.handleOpenModal}
              >
                <i className="fas fa-4x fa-play white absolute" />
                <img className="center pa3" src={imageUrl} alt="video preview" />
              </div>
            </div>
          }
          {this.renderQuantities()}
          {equipment &&
            <div className="measure-wide ma3 w-100">
              <h4>EQUIPMENT</h4>
              <p>{equipment}</p>
            </div>
          }
          {description &&
            <div className="measure-wide ma3 w-100">
              <h4>INSTRUCTIONS</h4>
              <p>{description}</p>
            </div>
          }
          <Button
            disabled={completed}
            onClick={this.handleComplete}
            className="ma3"
          >
            COMPLETE
            <i className="fas fa-check-circle ml2" />
          </Button>
        </div>
        {this.renderModal()}
      </div>
    );
  }
}

export default compose(
  graphql(COMPLETE_TASK, {
    props: ({ mutate }) => ({
      completeTask: (id, completed) => mutate({
        variables: { id, completed },
      }),
    }),
  }),
)(TaskDetail);
